export default __webpack_public_path__ + "static/media/fig-09-face-3d-log.7001a58c.png";